'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _antd = require('@adparlor-devops/antd');

var _GeneralInformation = require('./GeneralInformation');

var _GeneralInformation2 = _interopRequireDefault(_GeneralInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = _antd.Layout.Content,
    Footer = _antd.Layout.Footer;

var Step = _antd.Steps.Step;

var steps = [{
  title: 'General Information',
  content: _react2.default.createElement(_GeneralInformation2.default, null)
}, {
  title: 'Second',
  content: 'Second-content'
}, {
  title: 'Last',
  content: 'Last-content'
}];

var ManageDataSource = function (_Component) {
  (0, _inherits3.default)(ManageDataSource, _Component);

  function ManageDataSource(props) {
    (0, _classCallCheck3.default)(this, ManageDataSource);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ManageDataSource.__proto__ || (0, _getPrototypeOf2.default)(ManageDataSource)).call(this, props));

    _this.state = {
      current: 0
    };
    return _this;
  }

  (0, _createClass3.default)(ManageDataSource, [{
    key: 'next',
    value: function next() {
      var current = this.state.current + 1;
      this.setState({ current: current });
    }
  }, {
    key: 'prev',
    value: function prev() {
      var current = this.state.current - 1;
      this.setState({ current: current });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var current = this.state.current;

      return _react2.default.createElement(
        _antd.Layout,
        null,
        _react2.default.createElement(
          'h1',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manageDataSource.title', defaultMessage: 'Create Data Source' })
        ),
        _react2.default.createElement(
          Content,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _antd.Steps,
              { current: current },
              steps.map(function (item) {
                return _react2.default.createElement(Step, { key: item.title, title: item.title });
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'steps-content' },
              steps[this.state.current].content
            ),
            _react2.default.createElement(
              'div',
              { className: 'steps-action' },
              this.state.current < steps.length - 1 && _react2.default.createElement(
                _antd.Button,
                { type: 'primary', onClick: function onClick() {
                    return _this2.next();
                  } },
                'Next'
              ),
              this.state.current === steps.length - 1 && _react2.default.createElement(
                _antd.Button,
                { type: 'primary', onClick: function onClick() {
                    return message.success('Processing complete!');
                  } },
                'Done'
              ),
              this.state.current > 0 && _react2.default.createElement(
                _antd.Button,
                { style: { marginLeft: 8 }, onClick: function onClick() {
                    return _this2.prev();
                  } },
                'Previous'
              )
            )
          )
        ),
        _react2.default.createElement(Footer, { style: { textAlign: 'center' } })
      );
    }
  }]);
  return ManageDataSource;
}(_react.Component);

exports.default = (0, _reactIntl.injectIntl)(ManageDataSource);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/o2o/lib/modules/ManageDataSource/components/ManageDataSource.js
// module id = 4012
// module chunks = 9